import React from "react";
import '../css/technology.css';

function Technologies(props){
    return (
        <div class="technology">
            <img src={require(`../img/${props.imagen}.png`)} alt={ props.alt } />
            <span class="technology-name">{ props.name }</span>

        </div>
    );
}

export default Technologies;